import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import { ProposalViewList } from 'features/Proposal';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ProposalViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="proposal">
            <ProposalViewList />
          </Can>
          <Can not do="read" on="proposal">
            <h4 className="text-red-500">{t('permission.forbid.read.proposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default ProposalViewListPage;
